// Undelivered shared services must be disabled explicitly by isolated deployments.
// An absent flag preserves the existing behavior in other environments.
export const sharedIntegrationsAvailable = import.meta.env.VITE_DISABLE_SHARED_INTEGRATIONS !== 'true';
export const telemetryEnabled = import.meta.env.VITE_DISABLE_TELEMETRY !== 'true';

export const requireSharedIntegration = (integration: string): void => {
  if (!sharedIntegrationsAvailable) {
    throw new Error(`${integration} is unavailable.`);
  }
};
